// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2bb583f5","455":"e68ff67a","977":"1191d959"}[chunkId] + ".chunk.js";
};